import { useState } from "react";
import { GrPrevious, GrNext } from "react-icons/gr";
import TableElement from "../../Common/TableElement";
import ButtonElement from "../../Common/ButtonElement";

const TableComponent = ({ title, col = 2, breakPoint = "md", FilterComponent, TabComponent = null, headers, data, render, current, tableLoading, paginationAction, total = 0, limit = 200 }) => {
    const totalPages = Math.ceil(((total / limit) || 0));
    const [state, setState] = useState({
        prevRequest: false,
        nextRequest: false
    })
    const { prevRequest, nextRequest } = state;

    const nextHandler = async () => {
        if(!nextRequest){
            try{
                setState(prev => ({ ...prev, nextRequest: true }));
                if(paginationAction) await paginationAction(current + 1);
            }catch (ex) { } finally{
                setState(prev => ({ ...prev, nextRequest: false }));
            }
        }
    }

    const prevHandler = async () => {
        if(!prevRequest){
            try{
                setState(prev => ({ ...prev, prevRequest: true }));
                if(paginationAction) await paginationAction(current - 1);
            }catch (ex) { } finally{
                setState(prev => ({ ...prev, prevRequest: false }));
            }
        }
    }

    return <div className="table-section">
    <div className="row mb-2">
        <div className={`table-title col-${breakPoint}-${col} col-sm-12`}>
            <h4>{title}</h4>
        </div>
        <div className={`table-filter col-${breakPoint}-${12 - col} col-sm-12 text-md-end`}>{FilterComponent}</div>
    </div>
    {TabComponent}
    <TableElement loading={tableLoading} columns={headers} data={data} render={render} />
    {tableLoading ? null : data.length == 0 ? null : paginationAction ? <div className="table-footer">
        <ButtonElement text={<><GrPrevious style={{marginBottom: "2px"}} size={20} /><span>Previous</span></>} cssClass="small-radius" onClick={prevHandler} variant="btn-outline-grey" loading={prevRequest} disabled={current == 1}  />
        <p className="my-2">Page <span>{current}</span> of <span>{totalPages}</span> - Showing <span>{data?.length}</span></p>
        
        <ButtonElement text={<><GrNext style={{marginBottom: "2px"}} size={20} /><span>Next</span></>} cssClass="small-radius" onClick={nextHandler} variant="btn-outline-grey" loading={nextRequest} disabled={current == totalPages}/>
    </div> : null}
</div>
}

export default TableComponent;